export default "__VITE_ASSET__45de0871__"